
import Header from '@/core/components/Header.vue';
import Snackbar from '@/core/components/Snackbar.vue';
import SuccessAnimation from '@/core/components/SuccessAnimation.vue';
import CommonMixin from '@/core/pages/CommonMixin';
import { emitter } from './utils/constants';

export default CommonMixin.extend({
  data() {
    return {
      show_animation: false,
      default_language: 'de',
      languages: [
        { codes: [/de/i, /de-*/i], value: 'de' },
        { codes: [/en/i, /en-*/i], value: 'en' },
        { codes: [/fr/i, /fr-*/i], value: 'fr' },
        { codes: [/it/i, /it-*/i], value: 'it' },
      ],
    };
  },

  components: {
    Header,
    Snackbar,
    SuccessAnimation,
  },

  beforeCreate(): void {
    if (location.hash && !location.hash.includes('code=')) {
      // Removing the hash (#) will make the new routing system compatible with the old QR Codes.
      this.$router.replace(location.hash.slice(1));
    }
  },

  created() {
    this.$i18n.i18next.changeLanguage(this.getUserLanguage);

    emitter.on('success_animation', () => (this.show_animation = true));
  },
});
